
const urlQuery = window.location.search;
const urlParams = new URLSearchParams(urlQuery);
const isPJ = urlParams.get('utm_campaign') === 'movel_site_pj_fatura_facil';
const defaultCustomSection = !isPJ ? 'minha_claro_movel:fatura_facil' : 'minha_claro_movel_empresas:fatura_facil';  

function windowDataLayer(dataLayer) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(dataLayer)
}

const reportGA4 = ({event, customSection, customTitle, customCallback}) => {
  const customEvent = {
    'event': event ? event : 'clique',
    'custom_section': customSection ? customSection : defaultCustomSection,
    'custom_title': customTitle
  }

  if(!!customCallback) {
    Object.assign(customEvent, {"custom_callback": customCallback});
  }

  console.log('reportGA4', customEvent)

  windowDataLayer(customEvent);
}

const reportPageViewGA4 = ({event = "pageview", customSection, customTitle}) => {
  reportGA4({ event, customSection, customTitle });
}

export { reportGA4,  reportPageViewGA4 }